import { render, staticRenderFns } from "./EventMultiselect.vue?vue&type=template&id=353da9aa&"
import script from "./EventMultiselect.vue?vue&type=script&lang=js&"
export * from "./EventMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports